import { AmcVisitStatus } from "features/AmcVisitLogs/constants/amc-visit.constants";

function normalizeStatus(status: string | null | undefined): string {
  return String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
}

/** Visit is done or voided — no new assignments / reassignments. */
export function isTerminalAmcVisitForAssignment(
  status: string | null | undefined,
): boolean {
  const st = normalizeStatus(status);
  return (
    st === AmcVisitStatus.COMPLETED ||
    st === AmcVisitStatus.CANCELLED ||
    st === AmcVisitStatus.MISSED
  );
}

export function canReassignAmcVisit(status: string | null | undefined): boolean {
  return !isTerminalAmcVisitForAssignment(status);
}

export function shouldShowAmcVisitAssignmentActions(
  status: string | null | undefined,
): boolean {
  return !isTerminalAmcVisitForAssignment(status);
}
